import { createRouter, createWebHistory } from "vue-router";
import ReservationsPage from "@/modules/reservations/views/ReservationsPage.vue";
import ReservationDetailsPage from "@/modules/reservations/views/ReservationDetailsPage.vue";
import AuditPage from "@/modules/audit/views/AuditPage.vue";
import ResourcePage from "@/modules/resources/views/ResourcePage.vue";
import ResourceDetailPage from "@/modules/resources/views/ResourceDetailPage.vue";
import EventsPage from "@/modules/events/views/EventsPage.vue";
import EventDetailPage from "@/modules/events/views/EventDetailPage.vue";
import EventDetailEditPage from "@/modules/events/views/EventDetailEditPage.vue";
import DashboardPage from "@/modules/dashboard/views/DashboardPage.vue";
import ExecutiveDashboardPage from "@/modules/executiveDashboard/views/ExecutiveDashboardPage.vue";
import OccupationPage from "@/modules/occupation/views/OccupationPage.vue";
import UsersPage from "@/modules/users/views/UsersPage.vue";
import { isAuthenticated, login } from "@/modules/auth/services/authService";
import { RoutePath } from "@/core/models/route-path";
import { RouteName } from "@/core/models/route-name";
import EventTypesPage from "@/modules/eventType/views/EventTypesPage.vue";
const routes = [
  // First page - login
  {
    path: "/",
    name: "ReservationsAlias",
    component: ReservationsPage,
  },

  {
    path: "/reservations",
    name: "Reservations",
    meta: {
      headerTitleKey: "headerTitle.vehicleReservation",
    },
    component: ReservationsPage,
    beforeEnter: (to: any, from: any, next: () => void) => {
      if (!isAuthenticated()) {
        login();
      } else {
        next();
      }
    },
  },

  // Reservation details page (readonly)
  {
    path: "/reservations/:id",
    name: "ReservationDetails",
    component: ReservationDetailsPage,
    meta: {
      requiresAuth: true,
      title: "Detalhes da Reserva",
      headerTitleKey: "headerTitle.vehicleReservation",
    },
    props: true,
    beforeEnter: (to: any, from: any, next: () => void) => {
      if (!isAuthenticated()) {
        login();
      } else {
        next();
      }
    },
  },
  // Reservation edit page (edit mode)
  {
    path: "/reservations/:id/edit",
    name: "ReservationEdit",
    component: ReservationDetailsPage,
    meta: {
      requiresAuth: true,
      title: "Editar Reserva",
      headerTitleKey: "headerTitle.vehicleReservation",
    },
    props: true,
    beforeEnter: (to: any, from: any, next: () => void) => {
      if (!isAuthenticated()) {
        login();
      } else {
        next();
      }
    },
  },

  // Dashboard page
  {
    path: RoutePath.Dashboard,
    name: RouteName.Dashboard,
    component: DashboardPage,
    meta: {
      headerTitleKey: "headerTitle.manageEvents",
    },
    beforeEnter: (to: any, from: any, next: () => void) => {
      if (!isAuthenticated()) {
        login();
      } else {
        next();
      }
    },
  },

  // Resources page
  {
    path: RoutePath.Resources,
    name: RouteName.Resources,
    component: ResourcePage,
    meta: {
      headerTitleKey: "headerTitle.manageEvents",
    },
    beforeEnter: (to: any, from: any, next: () => void) => {
      if (!isAuthenticated()) {
        login();
      } else {
        next();
      }
    },
  },
  // Resource detail page (readonly)
  {
    path: RoutePath.ResourceDetail,
    name: RouteName.ResourceDetail,
    component: ResourceDetailPage,
    meta: {
      requiresAuth: true,
      title: "Detalhes do Evento",
      headerTitleKey: "headerTitle.manageEvents",
    },
    props: true,
    beforeEnter: (to: any, from: any, next: () => void) => {
      if (!isAuthenticated()) {
        login();
      } else {
        next();
      }
    },
  },

  // Eventos page
  {
    path: RoutePath.Events,
    name: RouteName.Events,
    component: EventsPage,
    meta: {
      headerTitleKey: "headerTitle.manageEvents",
    },
    beforeEnter: (to: any, from: any, next: () => void) => {
      if (!isAuthenticated()) {
        login();
      } else {
        next();
      }
    },
  },

  // Event detail page (readonly)
  {
    path: RoutePath.EventDetail,
    name: RouteName.EventDetail,
    component: EventDetailPage,
    meta: {
      requiresAuth: true,
      title: "Detalhes do Evento",
      headerTitleKey: "headerTitle.manageEvents",
    },
    props: true,
    beforeEnter: (to: any, from: any, next: () => void) => {
      if (!isAuthenticated()) {
        login();
      } else {
        next();
      }
    },
  },

  // Event detail page edit
  {
    path: RoutePath.EventDetailEdit,
    name: RouteName.EventDetailEdit,
    component: EventDetailEditPage,
    meta: {
      requiresAuth: true,
      title: "Detalhes do Evento editar",
      headerTitleKey: "headerTitle.manageEvents",
    },
    props: true,
    beforeEnter: (to: any, from: any, next: () => void) => {
      if (!isAuthenticated()) {
        login();
      } else {
        next();
      }
    },
  },

  // Event detail page (readonly)
  {
    path: RoutePath.Occupation,
    name: RouteName.Occupation,
    component: OccupationPage,
    meta: {
      requiresAuth: true,
      title: "Detalhes do Evento",
      headerTitleKey: "headerTitle.manageEvents",
    },
    props: true,
    beforeEnter: (to: any, from: any, next: () => void) => {
      if (!isAuthenticated()) {
        login();
      } else {
        next();
      }
    },
  },

  // Dashboard Executive page
  {
    path: RoutePath.DashboardExecutive,
    name: RouteName.DashboardExecutive,
    component: ExecutiveDashboardPage,
    meta: {
      requiresAuth: true,
      title: "Dashboard Executive",
      headerTitleKey: "headerTitle.manageEvents",
    },
    props: true,
    beforeEnter: (to: any, from: any, next: () => void) => {
      if (!isAuthenticated()) {
        login();
      } else {
        next();
      }
    },
  },

  //Users page
  {
    path: RoutePath.Users,
    name: RouteName.Users,
    component: UsersPage,
    meta: {
      requiresAuth: true,
      title: "Utilizadores",
      headerTitleKey: "headerTitle.guro",
      headerSubTitleKey: "headerTitle.fullGuro",
    },
    props: true,
    beforeEnter: (to: any, from: any, next: () => void) => {
      if (!isAuthenticated()) {
        login();
      } else {
        next();
      }
    },
  },

  //Audit users page
  {
    path: RoutePath.audit,
    name: RouteName.audit,
    component: AuditPage,
    meta: {
      requiresAuth: true,
      title: "Audit",
      headerTitleKey: "headerTitle.guro",
      headerSubTitleKey: "headerTitle.fullGuro",
    },
    props: true,
    beforeEnter: (to: any, from: any, next: () => void) => {
      if (!isAuthenticated()) {
        login();
      } else {
        next();
      }
    },
  },

  //Event types page
  {
    path: RoutePath.EventType,
    name: RouteName.EventType,
    component: EventTypesPage,
    meta: {
      requiresAuth: true,
      title: "Event Types",
      headerTitleKey: "headerTitle.manageEvents",
    },
    props: true,
    beforeEnter: (to: any, from: any, next: () => void) => {
      if (!isAuthenticated()) {
        login();
      } else {
        next();
      }
    },
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
